import { Button } from "@sellar-io/components";
import { PriceTierOrderRule } from "@sellar-io/api-v2/types";
import { useForm } from "react-hook-form";
import { v4 } from "uuid";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { usePriceTierOrderRuleDelete } from "../../../../hooks/api/v2/priceTierOrderRule/usePriceTierOrderRuleDelete";
import { usePriceTierOrderRuleUpdate } from "../../../../hooks/api/v2/priceTierOrderRule/usePriceTierOrderRuleUpdate";
import { OrderRuleForm } from "./OrderRuleForm";
import { PriceTierOrderRuleFormValues } from "./OrderRuleForm.shared";

const formId = v4();

export const OrderRuleDialogUpdate = ({
  priceTierOrderRule,
  active,
  onDismiss,
}: {
  priceTierOrderRule: Pick<PriceTierOrderRule, "id" | "itemType" | "quantity">;
  active: boolean;
  onDismiss: () => void;
}) => {
  const form = useForm<PriceTierOrderRuleFormValues>({
    shouldUseNativeValidation: true,
    defaultValues: priceTierOrderRule,
  });

  const priceTierOrderRuleUpdateMutation = usePriceTierOrderRuleUpdate(
    priceTierOrderRule.id,
  );
  const priceTierOrderRuleDeleteMutation = usePriceTierOrderRuleDelete(
    priceTierOrderRule.id,
  );

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={`Edit order rule`}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        <OrderRuleForm
          key={formId}
          form={form}
          formId={formId}
          onSave={(data) => {
            priceTierOrderRuleUpdateMutation.mutate(data, {
              onSuccess: () => {
                onDismiss();
              },
            });
          }}
        />
        {priceTierOrderRuleUpdateMutation.isError ? (
          <Alert
            message={
              apiV2AssertError(priceTierOrderRuleUpdateMutation.error)?.response
                ?.data.message ?? "Unknown error"
            }
          ></Alert>
        ) : null}
      </DialogContent>
      <DialogCTA>
        <Button
          color={"red"}
          loading={priceTierOrderRuleDeleteMutation.isPending}
          onClick={() =>
            priceTierOrderRuleDeleteMutation.mutate(undefined, {
              onSuccess: () => onDismiss,
            })
          }
        >
          Delete
        </Button>
        <Button
          loading={priceTierOrderRuleUpdateMutation.isPending}
          form={formId}
          type={"submit"}
        >
          Update
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
